// TODO(Babel 8): Remove this file

exports.getModuleName = () =>
  require("@babel/helper-module-transforms").getModuleName;
